import { appApi } from 'dux/app/api';

type SubscriptionPreview = Array<{
  frequency: number;
  next_start_date: string;
  product: string;
  quantity: number;
  total_price: number;
  total_price_display: number;
}>;

const checkoutApiSlice = appApi.injectEndpoints({
  endpoints: (build) => ({
    checkoutSubscriptionPreview: build.query<SubscriptionPreview, void>({
      query: () => ({
        url: `v1/account/cart/subscription_preview`,
        endpointName: 'checkout/subscriptionPreview',
      }),
      keepUnusedDataFor: 0, // no caching for now
    }),

    checkoutOrder: build.query<any, { pubkey: string }>({
      query: (data) => ({
        url: `v1/checkout/${data.pubkey}/`,
        endpointName: 'checkout/checkoutOrder',
      }),
      keepUnusedDataFor: 0, // no caching for now
    }),
  }),
});

export const { useCheckoutSubscriptionPreviewQuery, useCheckoutOrderQuery } = checkoutApiSlice;
